import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "search-bar" }
const _hoisted_2 = { class: "search-bar__filters-toggle-wrapper" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "search-bar__count" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.showSearchInput)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: _normalizeClass(["search-bar__filters-toggle", $setup.show_filters ? 'search-bar__filters-toggle--toggled': 'search-bar__filters-toggle--untoggled']),
              onClick: _cache[0] || (_cache[0] = $event => ($setup.show_filters = !$setup.show_filters))
            }, _toDisplayString($setup.show_filters ? 'Close filter' : 'Filter') + _toDisplayString($setup.total_filter_count ? ' (' + $setup.total_filter_count + ')' : ''), 3 /* TEXT, CLASS */)
          ]),
          _createElementVNode("div", {
            class: "search-bar__field a4-12",
            onClick: $setup.focusSearch
          }, [
            _withDirectives(_createElementVNode("input", {
              ref: "search_filter_input",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.search_query) = $event)),
              class: "search__input",
              type: "text",
              placeholder: $props.inputPlaceholder,
              onInput: $setup.handleSearchInputChange
            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_3), [
              [_vModelText, $setup.search_query]
            ])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("p", _hoisted_4, " Showing " + _toDisplayString($setup.pagination.total_count) + " result" + _toDisplayString($setup.pagination.total_count === 1 ? '' : 's'), 1 /* TEXT */),
    ($setup.props.storeKey === 'database')
      ? (_openBlock(), _createBlock($setup["DatabaseSortingAndDateFilterComponent"], { key: 1 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          ($setup.active_tab !== 'example_projects')
            ? (_openBlock(), _createBlock($setup["ProjectSortingAndDateFilterComponent"], { key: 0 }))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}